/*
 * Public API Surface of theme
 */

export * from './lib/theme.component';
export * from './lib/theme.module';
export * from './theme';
